import MagnifyingGlassIcon from '@heroicons/react/24/solid/MagnifyingGlassIcon';
import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import {
  Grid,
  IconButton,
  InputAdornment,
  type InputBaseComponentProps,
  OutlinedInput,
  SvgIcon,
  Tooltip,
} from '@mui/material';
import { useRef } from 'react';

import { gridSizeMdLg2 } from '@/shared/constants';
import Flatpickr from 'react-flatpickr';
import DateRangePicker from './DateRangePicker';

export interface CustomSearchInterface {
  value: string;
  text: string;
  disabled?: boolean;
  showCustomBox?: boolean;
  customBox?: React.ReactNode;
  onChangeRangeDate?: (range: Date[]) => void;
  cleanFilter?: () => void;
  onChange: (value: any) => void;
  inputProps?: InputBaseComponentProps ;
}

const CustomSearch: React.FC<CustomSearchInterface> = ({
  onChange,
  value,
  text,
  //disabled=false,
  //filter date
  onChangeRangeDate,
  cleanFilter,

  // custom box
  showCustomBox = false,
  customBox,
  //inputProps,
}) => {
  const flatpickrRef = useRef<Flatpickr>(null);
  const onCleanSearch = () => {
    if (cleanFilter) {
      cleanFilter();
      return;
    }

    onChange('');
  };

  return (
    <Grid
      item
      container
      sx={{ py: 2 }}
      spacing={1}
      alignItems="center"
      justifyContent={'space-between'}
    >
      <Grid item xs={12} sm={12} md={5} lg={5}>
        <OutlinedInput
          name='search-custom'
          fullWidth
          placeholder={`Buscar ${text}`}
          startAdornment={
            <InputAdornment position="start">
              <SvgIcon color="action" fontSize="small">
                <MagnifyingGlassIcon />
              </SvgIcon>
            </InputAdornment>
          }
          endAdornment={
            value.length > 0 ?
              <InputAdornment position="end">
                <SvgIcon
                  onClick={onCleanSearch}
                  style={{ display: "flex", justifyContent: "end", cursor: "pointer" }}
                  color="action" fontSize="small">
                  <XMarkIcon />
                </SvgIcon>
              </InputAdornment>
              : null
          }
          //className="custom-search-form__input"
          value={value}
          onChange={e => {
            onChange(e.target.value);
          }}
        />

      </Grid>

      {showCustomBox && (
        <Grid
          item
          container
          xs={12}
          sm={12}
          md={5}
          lg={5}
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          {customBox}
        </Grid>
      )}

      {/* ////* filter date */}
      {onChangeRangeDate && (

        <Grid
          container
          item
          xs={12}
          sm={12}
          md={3}
          lg={3}
          alignItems={'center'}
        >
          <DateRangePicker
            flatpickrRef={flatpickrRef}
            onChange={range => onChangeRangeDate(range)}
          />

          <Grid item {...gridSizeMdLg2}>
            <Tooltip title="Limpiar">
              <IconButton
                onClick={() => {
                  //LIMPIAR RANGO DE FECHAS FRONT
                  if (flatpickrRef.current) {
                    flatpickrRef.current.flatpickr.clear();
                  }

                  cleanFilter && cleanFilter();
                }}
              >
                <FilterAltOffIcon />
              </IconButton>
            </Tooltip>
          </Grid>
          {/* <SvgIcon 
          onClick={()=>{cleanFilter}}
          style={{ display:"flex", justifyContent:"end", cursor:"pointer"}}
          color="action" fontSize="small">
            <XMarkIcon/>
          </SvgIcon> */}
        </Grid>

      )}


    </Grid>
  );
};

export default CustomSearch;
